import { render, staticRenderFns } from "./TaskViewFooterBar.vue?vue&type=template&id=fb13f3c4&scoped=true&lang=pug&"
import script from "./TaskViewFooterBar.vue?vue&type=script&lang=js&"
export * from "./TaskViewFooterBar.vue?vue&type=script&lang=js&"
import style0 from "./TaskViewFooterBar.vue?vue&type=style&index=0&id=fb13f3c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb13f3c4",
  null
  
)

export default component.exports